import React from 'react';
import PropTypes from 'prop-types';
import './helpContactUs.scss';
import MarqueImage from './MarqueeImage';

function ReferenceMaterial({ path }) {
  const referenceImage = '/images/reference-materials-marquee.jpg';

  return (
    <MarqueImage image={referenceImage} titleName="Reference Materials" path={path} />
  );
}

ReferenceMaterial.propTypes = {
  path: PropTypes.string,
};

export default ReferenceMaterial;
